import React from 'react';
import '../styles/fonts.css';
import ContactForm from './ContactForm';

const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

function Services() {
    return (
        <div className="overflow-x-hidden" style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
        }}>
            <div className="gradient-circle-flipped gradient-circle-left"></div>
            <div className="gradient-circle gradient-circle-right"></div>
            
            {/* Banner section outside the max-width container */}
            <div className="w-100 position-relative">
                <img
                    src="/homeBanner.png"
                    alt="Home Banner"
                    className="img-fluid w-100"
                    style={{
                        height: 'clamp(300px, 50vh, 300px)',
                        objectFit: 'cover'
                    }}
                />
                <div className="position-absolute top-50 start-0 w-100 translate-middle-y">
                    <div className="mx-auto" style={{ maxWidth: '1270px' }}>  {/* Banner content constrained */}
                        <div className="container-fluid px-4 px-md-5">
                            <div className="row justify-content-center">
                                <div className="col-12 col-lg-10">
                                    <div className="text-white">
                                        <img
                                            src="/textLogo.png"
                                            alt="Home Banner"
                                            className="img-fluid"
                                            style={{
                                                maxWidth: '300px',
                                                width: '80%',
                                                objectFit: 'contain',
                                                display: 'block'
                                            }}
                                        />
                                        <div className="text-start">
                                            <h1 className="display-5 my-2" style={{
                                                fontFamily: 'Avenir, sans-serif',
                                                fontSize: 'clamp(20px, 3.5vw, 36px)',
                                                fontWeight: '700'
                                            }}>
                                                Services
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Max-width container for the rest of the content */}
            <div style={{ maxWidth: '1728px', margin: '0 auto' }}>
                {/* Services Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                Our Services
                            </h1>
                            <div className="row d-flex align-items-center justify-content-between mb-4">
                                <div className="col-auto">
                                    <h2 className="mb-2 text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '36px', fontWeight: 'bold' }}>
                                        Tech-Driven, Future Ready
                                    </h2>
                                </div>
                            </div>

                            <div className="row row-cols-1 g-0">
                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: 'clamp(20px, 2.5vw, 28px)'
                                                }}>Digital Transformation</h5>
                                                <span className="card-text font-weight-bold d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                    <span>(Server Hardware)</span>
                                                </span>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/services/digitalTransformation-sm.png" alt="Server Hardware" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',       
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "Data Center Solutions",
                                                            description: "High-performance servers, storage solutions, and network infrastructure for enterprise-level operations."
                                                        },
                                                        {
                                                            title: "Cloud Infrastructure",
                                                            description: "On-premise and hybrid cloud setup with scalability options."
                                                        },
                                                        {
                                                            title: "Network Architecture",
                                                            description: "VMware, Hyper-V, and other virtualization services to optimize resource utilization."
                                                        }
                                                    ].map((item, index) => (
                                                        <div className="row " key={index}>
                                                            <div className="row">
                                                                <div className='col'>
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(16px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: 'clamp(20px, 2.5vw, 28px)'
                                                }}>Enterprise Solutions</h5>
                                                <span className="card-text font-weight-bold d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                    <span>(System Integration)</span>
                                                </span>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/services/systemIntegration-sm.png" alt="System Integration" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "ERP & CRM Integration",
                                                            description: "Seamlessly connect enterprise resource planning (ERP) and customer relationship management (CRM) systems for better workflow."
                                                        },
                                                        {
                                                            title: "IT Infrastructure Integration",
                                                            description: "Unifying multiple IT systems, applications, and databases into a single cohesive ecosystem."
                                                        },
                                                        {
                                                            title: "Cybersecurity Integration",
                                                            description: "Implementing enterprise-wide security protocols, firewalls, and threat monitoring systems."
                                                        }
                                                    ].map((item, index) => (
                                                        <div className="row" key={index}>
                                                            <div className="row">
                                                                <div className='col'>
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(16px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: 'clamp(20px, 2.5vw, 28px)'
                                                }}>Software Development</h5>
                                                <span className="card-text font-weight-bold d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                    <span>(Custom Applications)</span>
                                                </span>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/services/customApplications-sm.png" alt="Custom Applications" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "Business Process Automation",
                                                            description: "Custom-built applications to automate internal processes like HR, finance, and operations."
                                                        },
                                                        {
                                                            title: "AI & Data Analytics Platforms",
                                                            description: "Scalable applications for iOS, Android, and web-based platforms."
                                                        },
                                                        {
                                                            title: "Mobile & Web Application Development",
                                                            description: "Predictive analytics, business intelligence dashboards, and AI-powered decision-making tools."
                                                        }
                                                    ].map((item, index) => (
                                                        <div className="row" key={index}>
                                                            <div className="row">
                                                                <div className='col'>
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(16px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: 'clamp(20px, 2.5vw, 28px)'
                                                }}>Maintenance & Support</h5>
                                                <span className="card-text font-weight-bold d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                    <span>(Managed Services)</span>
                                                </span>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/services/manageService-sm.png" alt="Managed Services" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "24/7 IT Support & Monitoring",
                                                            description: "Real-time system monitoring, troubleshooting, and helpdesk services."
                                                        },
                                                        {
                                                            title: "Backup & Disaster Recovery",
                                                            description: "Ensuring business applications stay up-to-date with security and performance patches."
                                                        },
                                                        {
                                                            title: "Software Updates & Patch Management",
                                                            description: "Implementing cloud-based and on-premise backup solutions to prevent data loss."
                                                        }
                                                    ].map((item, index) => (
                                                        <div className="row" key={index}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(16px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Us Section */}
                <ContactForm />
            </div>
        </div>
    );
}

export default Services; 